import React from 'react'

class WindowDimensions extends React.Component {
  state = {
      width: '0',
      height: '0',
      currentPath: ''
  };

  componentDidMount() {
      this.updateWindowDimensions();
      if (window) {
          window.addEventListener('resize', this.updateWindowDimensions);
      }
  }

  componentWillUnmount() {
      if (window) {
          window.removeEventListener('resize', this.updateWindowDimensions);
      }
  }

  updateWindowDimensions = () => {
      if (window) {
          this.setState({
              width: window.innerWidth,
              height: window.innerHeight
          });
      }
  };

  render() {
      let children;
      if (this.state.width > 0) {
          children = React.Children.map(this.props.children, child =>
              React.cloneElement(child, this.state)
          );
      } else {
          children = this.props.children;
      }

      return (
          <div>
              {children}
              <style jsx>{`
                  div {
                      height: 100%;
                  }
              `}</style>
          </div>
      );
  }
}

export default WindowDimensions;


// WEBPACK FOOTER //
// ./src/components/windowDimensions/index.js